require("froala-editor/js/froala_editor.pkgd");
require("froala-editor/css/froala_editor.pkgd.min.css");
require("froala-editor/css/froala_style.min.css");
const jquery = require("jquery");
window.$ = jquery;

import template from "arctic-vuejs-template";
import VueFroala from "vue-froala-wysiwyg";
import Vue from "vue";
import { sync } from "vuex-router-sync";

import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

Vue.use(VueFroala);

sync(store, router);

Vue.component("arctic-template", template);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
